export default __webpack_public_path__ + "static/media/doctor.c4f87873.jpg";